export const PLAYGROUND_USERS = ['57148612Y']; // Playground page allowed users

export enum IconsForButtons {
    None = '',
    Left = 'fa fa-chevron-left',
    Save = 'fa fa-save',
    File = 'fa fa-file-o',
    Excel = 'fa fa-file-excel-o',
    spinnerExcel = 'spinnerExcel',
}

export const FormatDate = 'dd/MM/yyyy';

export enum ColFieldType {
    Codigo = 'Codigo',
    Link = 'Link',
    Image = 'Image',
    FechaEnvio = 'FechaEnvio',
    FechaInspeccion = 'FechaInspeccion',
    EsPredua = 'EsPredua',
    PesoNeto = 'PesoNeto',
    TipoSolicitud = 'TipoSolicitud',
    CodigoTipoSolicitud = 'CodigoTipoSolicitud',
    IdEstadoSolicitud = 'IdEstadoSolicitud',
    EstadoSolicitud = 'EstadoSolicitud',
}

export enum ActionAbility {
    Editable = 'Editable',
    Visible = 'Visible',
}
